import * as Yup from "yup";

/**
 * Login form validator for login
 */
const specialCharRestrict = "^[A-Za-z0-9 ]+$";
const countryCode = "^[0-9][0-9]$";
export const loginFromValidator = {
  initialValues: {
    email: "",
    password: "",
  },
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email field cannot be empty"),
    password: Yup.string()
      .min(8, "Must be 8 or more than 8 characters")
      .required("Password field is Required")
      .matches(/\w/, "Please enter valid password"),
  }),
};
//sign up form
export const signupFromValidatorUser = {
  initialValues: {
    password: "",
    fname: "",
    lname: "",
    email: "",
    confirmEmail: "",
    countryCode: "65",
    phoneNumber: "",
    dob: new Date(),
    property_type: "HDB",
    // unitNo: "",
    postalCode: "",
    country: "",
    addressName: "",
    generalLocation: "",
    isNotify: false
  },
  validationSchema: Yup.object().shape({
    password: Yup.string()
      .min(8, "Must be 8 or more than 8 characters")
      .required("Password field is Required")
      .matches(/\w/, "Please enter valid password"),
    fname: Yup.string()
      .required("This field is required.")
      .matches(specialCharRestrict, "Special character not allowed"),
    lname: Yup.string()
      .required("This field is required.")
      .matches(specialCharRestrict, "Special character not allowed"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .min(8, "Too short,8 digits required"),
    countryCode: Yup.string()
      .required("This field is required.")
      .matches(countryCode, "Max 2 digit required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email field cannot be empty"),
    country: Yup.string().required("Country field cannot be empty"),
    confirmEmail: Yup.string()
      .oneOf([Yup.ref("email"), ""], "Email must match")
      .email("Invalid email address")
      .required("Email field cannot be empty"),
    property_type: Yup.string().required("This field is required."),
    dob: Yup.string().required("This field is required."),
    // unitNo: Yup.string().required("Unit no is required"),
    postalCode: Yup.string().required("Postal code is required"),
    country: Yup.string().required("Country is required"),
    addressName: Yup.string().required("Address name is required"),
    // generalLocation: Yup.string().required("Location is required"),
  }),
};
export const forgotPassFromValidator = {
  initialValues: {
    email: "",
  },
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email field cannot be empty"),
  }),
};

export const verifyOtpFromValidator = {
  initialValues: {
    otp: "",
  },
  validationSchema: Yup.object().shape({
    otp: Yup.string().required("OTP field cannot be empty"),
  }),
};

export const resetPassFormValidator = {
  initialValues: {
    newPassword: "",
    confrmPassword: "",
  },
  validationSchema: Yup.object().shape({
    newPassword: Yup.string()
      .min(8, "Must be 8 or more than 8 characters")
      .required("Password field is Required")
      .matches(/\w/, "Please enter valid password"),
    confrmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), ""], "Password must match")
      .required("Confirm password field is required")
      .matches(/\w/, "Please enter valid password"),
  }),
};

//This sign up form for order create
export const signupFromValidatorOrderCreate = (
  prevData,
  selectedAddress,
  type,
  customer
) => {
  if (type === "initialValues") {
    let initialValues = {
      /////////
      password: "",
      fname: prevData?.fname ?? "",
      lname: prevData?.lname ?? "",

      email: prevData?.email ?? "",
      confirmEmail: prevData?.email ?? "",
      countryCode: "65",
      phoneNumber: prevData?.phoneNumber ?? "",
      dob: prevData?.customer?.dob ?? new Date(),
      property_type: prevData?.customer?.property_type ?? "HDB",
      // unitNo: "",
      postalCode: selectedAddress?.postalCode ?? "",
      country: selectedAddress?.country ?? "",
      // title: selectedAddress?.title ?? "",
      unitNo: selectedAddress?.unitNo ?? "",
      address: selectedAddress?.address ?? "",
      isNotify: false,
      // generalLocation: "",
    };
    return initialValues;
  } else if (type === "validationSchema") {
    const specialCharRestrict = "^[A-Za-z0-9 ]+$";
    let validationSchema = Yup.object().shape({
      password: Yup.string()
        .min(8, "Must be 8 or more than 8 characters")
        .required("Password field is Required")
        .matches(/\w/, "Please enter valid password"),
      fname: Yup.string()
        .required("This field is required.")
        .matches(specialCharRestrict, "Special character not allowed"),
      lname: Yup.string()
        .required("This field is required.")
        .matches(specialCharRestrict, "Special character not allowed"),
      phoneNumber: Yup.string()
        .required("Phone number is required")
        .min(8, "Too short,8 digits required"),
      // countryCode: Yup.string()
      //   .required("This field is required.")
      //   .matches(countryCode, "Max 2 digit required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email field cannot be empty"),
      country: Yup.string().required("Country field cannot be empty"),
      confirmEmail: Yup.string()
        .oneOf([Yup.ref("email"), ""], "Email must match")
        .email("Invalid email address")
        .required("Email field cannot be empty"),
      property_type: Yup.string().required("This field is required."),
      dob: Yup.string().required("This field is required."),
      // unitNo: Yup.string().required("Unit no is required"),
      postalCode: Yup.string().required("Postal code is required"),
      country: Yup.string().required("Country is required"),
      address: Yup.string().required("Address line 1 is required"),
      // addressName: Yup.string().required("Address name is required"),
      // generalLocation: Yup.string().required("Location is required"),
    });
    return validationSchema;
  }
};

export const addressFromValidatorOrderCreate = (
  prevData,
  selectedAddress,
  type
) => {
  if (type === "initialValues") {
    let initialValues = {
      postalCode: selectedAddress?.postalCode ?? "",
      country: selectedAddress?.country ?? "",
      unitNo: selectedAddress?.unitNo ?? "",
      address: selectedAddress?.address ?? "",
      title: selectedAddress?.title ?? "",
    };
    return initialValues;
  } else if (type === "validationSchema") {
    let validationSchema = Yup.object().shape({
      postalCode: Yup.string().required("Postal code is required"),
      country: Yup.string().required("Country is required"),
      address: Yup.string().required("Address 1 is required"),
    });
    return validationSchema;
  }
};
